import useApiQuery from '@hooks/useApiQuery';
import QueryKeys from '@src/constants/queryKeys';
import { Device } from '@src/types/Device';

export interface UseGetDevicesFilteredBody {
  filter: {
    type?: {
      $in: string[];
    };
    engineeringId?: string;
    parentControllerId?: string;
  };
}
interface UseGetDevicesProps {
  body: UseGetDevicesFilteredBody;
  options?: { enabled?: boolean; queryKeys?: string[] };
}

export default ({
  body,
  options,
}: UseGetDevicesProps): ReturnType<typeof useApiQuery<Device[]>> =>
  useApiQuery<Device[]>({
    queryKey: [
      QueryKeys['widget-config-internal'],
      [...(options?.queryKeys || [])].join('-'),
    ],
    apiPath: '/devices/search',
    method: 'POST',
    useV2API: true,
    body,
    enabled: typeof options?.enabled === 'boolean' ? options.enabled : true,
  });
